export const minmax = (val, min, max) => Math.max(Math.min(val, max), min);
